import React from 'react';
export function FounderStory() {
  return <section className="section-padding bg-white" data-id="element-357">
      <div className="container-custom" data-id="element-358">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center max-w-7xl mx-auto" data-id="element-359">
          {/* Photo - Shows first on mobile, left on desktop */}
          <div className="order-1" data-id="element-360">
            <div className="relative" data-id="element-361">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl" data-id="element-362">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5gzTFgtsYUBAhaD6tWDvz7/Peter_and_Jake.jpg" alt="Peter & Jake Swenson" className="w-full h-full object-cover" data-id="element-363" />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-amber rounded-xl p-6 shadow-xl" data-id="element-364">
                <div className="text-navy text-center" data-id="element-365">
                  <div className="text-3xl font-bold" data-id="element-366">200K+</div>
                  <div className="text-sm font-semibold" data-id="element-367">Doors Knocked</div>
                </div>
              </div>
            </div>
          </div>

          {/* Content - Shows second on mobile, right on desktop */}
          <div className="order-2" data-id="element-368">
            <h2 className="mb-6" data-id="element-369">Peter & Jake Swenson</h2>
            <div className="space-y-6 leading-relaxed" data-id="element-370">
              <p data-id="element-371">
                Peter and Jake Swenson bring more than 40 years of combined
                experience in the door-to-door space. They started in 2005, and
                for 15 years, they did it the hard way – hiring, training, and
                managing over 2,000 reps manually. They lived the daily grind of
                inconsistent recruiting and leadership burnout.
              </p>
              <p data-id="element-372">
                In 2020, they decided to stop guessing. They began engineering
                The HIRE Advantage system, spending the next four years
                (2021–2024) refining it in the trenches.
              </p>
              <p className="font-semibold text-navy" data-id="element-373">
                The result? The system recruited another 2,000 reps. That rookie
                talent generated over $100M in sales production (contributing to
                over $130M in total organizational revenue).
              </p>
              <div className="bg-gray-50 rounded-lg p-6 border-l-4 border-amber" data-id="element-374">
                <p className="font-semibold text-navy mb-3" data-id="element-375">
                  It was through that deep experience that they realized the
                  rest of the industry had a massive problem:
                </p>
                <ul className="space-y-2" data-id="element-376">
                  <li data-id="element-377">• Most companies were just "hiring bodies."</li>
                  <li data-id="element-378">• Reps were slipping through the cracks.</li>
                  <li data-id="element-379">• Leaders were burning out.</li>
                  <li data-id="element-380">• Rookies were quitting because they had no support.</li>
                </ul>
              </div>
              <p data-id="element-381">
                <span className="font-bold text-navy" data-id="element-382">
                  Now, they install that same system for other high-growth
                  teams.
                </span>
              </p>
              <p data-id="element-383">
                It's not just about hiring people – it's about building a
                framework where they can actually succeed.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}